import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Scale } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const navigate = useNavigate();
  const { checkAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    (async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        await checkAuth();
        navigate("/dashboard");
      } catch {
        navigate("/login");
      }
    })();
  }, [navigate, checkAuth]);

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-navy text-white">
      <div className="flex h-14 w-14 items-center justify-center rounded-md bg-gold text-navy">
        <Scale className="h-7 w-7" />
      </div>
      <p className="mt-4 font-display text-2xl">Signing you in…</p>
      <div className="mt-4 h-5 w-5 animate-spin rounded-full border-2 border-white/40 border-t-white" />
    </div>
  );
}
